import React from 'react'
import styled, { css } from 'styled-components'
import FlipMove from 'react-flip-move'

import DetailedBoardRow from './DetailedBoardRow'
import { ZERO_WIDTH_SPACE } from '../unicodeChars'
import { sortPlayersByChapterRanks } from '../utils'

import { useSearchParams } from 'react-router-dom'

import { useStore } from '../zustandStore'

const SCALE_FACTOR = 1.15
const RANK_CHANGE_ANIMATION_MS = 500

// component is useful for both Divisions and Brackets, so the name is a bit general
const DetailedBoardTitledGroupOfRows = ({ 
  playerSlugs,
  groupTitle,
  chapterNames,
  nameColumnWidthPercent = 30,
  msDecimals = 3,
  getRowProps = () => ({}),
  appendedRowClassName = '',
  appendedHeaderClassName = '',
  sortingByChapterName = null,
  disableAllAnimations = false,
  rankOverrideKey,
  suppressLiveIcon = false,
  animationDuration,
  chapterTimeSpacerStrings,
  totalTimeSpacerString
}) => {
  const {
    // players,
    // TEMP PLAYERS_NEW
    playersNew,
    obsState,
  } = useStore(state => ({
    // players: state.players,
    // TEMP PLAYERS_NEW
    playersNew: state.playersNew,
    obsState: state.obsState,
  }))

  // TEMP PLAYERS_NEW
  const displayedPlayers = playerSlugs.map((slug) => slug ? playersNew[slug] : {})
  const sortedPlayers = sortingByChapterName == null ? displayedPlayers : sortPlayersByChapterRanks(displayedPlayers, sortingByChapterName)
  // debugger
  const [queryParams, _] = useSearchParams()

  return (<>
    <StyledHeader className={`group-header ${appendedHeaderClassName}`} key={0}>{groupTitle}</StyledHeader>
    <StyledFlipMove className="rows-container" key={1} 
      enterAnimation="accordionVertical" leaveAnimation="accordionVertical" 
      maintainContainerHeight duration={animationDuration || RANK_CHANGE_ANIMATION_MS}
      disableAllAnimations={disableAllAnimations}
    >
      {sortedPlayers.map((player, i) => {
        let className = 'row'
        className += ` KEY-${getRowProps(player)?.key || player.slug || i}`
        className += (i % 2 === 0 ? ' row-even' : ' row-odd')
        className += (i == 0 ? ' row-first' : '')
        className += (i == sortedPlayers.length - 1 ? ' row-last' : '')
        className += ' ' + (appendedRowClassName || '')
        // debugger
        return (
          <DetailedBoardRow
            isPlaceholder={!player.slug}
            className={className}
            key={player.slug || i}
            chapterNames={chapterNames}
            player={player}
            includeTotal
            scaleBy={SCALE_FACTOR}
            nameColumnWidthPercent={nameColumnWidthPercent}
            msDecimals={msDecimals}
            rankOverrideKey={rankOverrideKey}
            chapterTimeSpacerStrings={chapterTimeSpacerStrings}
            totalTimeSpacerString={totalTimeSpacerString}
            {...getRowProps(player)}
            isLive={queryParams.get('help')
              ? i === 0 || i % 3 === 0
              : !suppressLiveIcon && obsState.livePlayerSlugs.includes(player.slug)
            }
          />       
        )

      })}
    </StyledFlipMove>
  </>)
}

export default DetailedBoardTitledGroupOfRows


const StyledFlipMove = styled(FlipMove)`
  width: 100%;
  .row > * {
    margin: 0 0 2px 0 !important;
  }
`

const StyledHeader = styled.div`
  flex-grow: 1;
  flex-direction: column;
  display: flex;
  color: #ccc;
  justify-content: center;
  text-transform: uppercase;
  border-top: 2px solid #aaa;
  border-bottom: 2px solid #aaa;
  box-sizing: border-box;
  padding-bottom: 0.07em;
  /* background-color: #8e44b03d; */
  background: var(--gradient-background);
  
  
  /* font-size: ${() => DIVISION_HEADER_FONT_SIZE_PX}px; */
  /* height: ${props => (100 - HEADER_HEIGHT_VH) / props.pageSize}vh; */
  
  /* margin: 20px 0 0px 0; */
  /* min-height: ${() => DIVIDER_HEIGHT_VH}vh;
  max-height: ${() => DIVIDER_HEIGHT_VH}vh; */
  /* display: block; */
  /* padding-left: 2vw; */

  /* width: calc(100vw + ${props => MANUALLY_ADJUSTED_SHIFT_RIGHT_PX}px); */
  /* padding-left: calc(1.3vw + ${props => MANUALLY_ADJUSTED_SHIFT_RIGHT_PX}px); */
  /* margin-left: ${props => -1 * MANUALLY_ADJUSTED_SHIFT_RIGHT_PX}px; */
`
